<template>
  <div class="card card-body rounded-top">
    <component-table
      actionsWidth="300px"
      addButtonText="buttons.add"
      entityType="team"
      addButtonPermissions="TEAM.UPDATE"
      :addButtonEntityId="teamId"
      :actions="actions"
      :hideSearchInput="true"
      :columns="columns"
      :data="list"
      :total="count"
      @add="showAddModal"
      @viewMedicalExaminations="goToMedicalExaminations($event.id)"
      @viewExamResults="goToExamResults($event.id)"
      @delete="showDeleteDialog($event.id)"
      @createAccount="createAccount($event.id)"
    />

    <player-modal :show="showModal" @save="addPlayer" @close="hideModal" />

    <account-modal :show="showAccountModal" :profileId="profileId" @save="register" @close="hideAccountModal" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import accountModal from '@/components/modals/team/AccountModal';
import playerModal from '@/components/modals/team/PlayerModal';
import ComponentTable from '@/components/table/Table';
import { modalMixin } from '@/mixins/modal';
import { teamResource } from '@/resources/team.resource';
import {
  MEDICAL_EXAMINATION_ACTION,
  EXAM_RESULT_ACTION,
  CREATE_ACCOUNT_ACTION,
  DELETE_ACTION
} from '@/utils/constants';
import { tryParseInt } from '@/utils/number';

// @vuese
// Lista zawodników
// @group Team
export default {
  mixins: [modalMixin('team', {})],
  data() {
    return {
      actions: [MEDICAL_EXAMINATION_ACTION, EXAM_RESULT_ACTION, CREATE_ACCOUNT_ACTION, DELETE_ACTION],
      columns: [
        {
          name: 'firstName',
          displayName: 'columns.firstName'
        },
        {
          name: 'lastName',
          displayName: 'columns.lastName'
        },
        {
          name: 'phoneNumber',
          displayName: 'columns.phoneNumber'
        },
        {
          name: 'email',
          displayName: 'columns.email'
        }
      ],
      showAccountModal: false,
      profileId: undefined
    };
  },
  computed: {
    teamId() {
      return this.$route.params.teamId;
    },
    ...mapState({
      list(state) {
        return state.team.player.list;
      },
      count(state) {
        return state.team.player.count;
      }
    })
  },
  methods: {
    // @vuese
    // Dodaje zawodnika do grupy treningowej
    addPlayer(data) {
      teamResource
        .playerAdd(data.profile, data.teamId)
        .then(id => {
          data.profile.id = id;
          this.$store.dispatch('team/player/add', data.profile);
        })
        .then(() => this.$store.dispatch('notifySuccess', { title: 'messages.players.add' }))
        .catch(() => this.$store.dispatch('notifyError', { title: 'messages.players.addError' }));
    },
    // @vuese
    // Przechodzi do listy badań lekarskich
    goToMedicalExaminations(playerId) {
      this.$router.push({ name: 'teamPlayerMedicalExamination', params: { playerId } });
    },
    // @vuese
    // Przechodzi do wyników egzaminu
    goToExamResults(playerId) {
      this.$router.push({ name: 'teamPlayerExamResult', params: { playerId } });
    },
    // @vuese
    // Otwiera modal tworzenia konta
    createAccount(playerId) {
      this.profileId = playerId;
      this.showAccountModal = true;
    },
    // @vuese
    // Otwiera okienko z potwierdzeniem usunięcia
    showDeleteDialog(id) {
      this.$store.dispatch('showConfirm', {
        title: this.$t('text.delete-dialog-title'),
        description: this.$t('messages.players.deleteConfirm'),
        onSuccess: () => this.remove(id)
      });
    },
    // @vuese
    // Usuwa encję
    remove(id) {
      this.$store
        .dispatch('team/player/remove', { id, filters: { teamId: tryParseInt(this.teamId) } })
        .then(() => this.notifySuccess('messages.players.deleted'))
        .catch(err => this.notifyError('messages.players.deleteError'));
    },
    // @vuese
    // Ukrywa modal tworzenia konta
    hideAccountModal() {
      this.$set(this, 'showAccountModal', false);
      this.$set(this, 'profileId', undefined);
    },
    // @vuese
    // Rejestruje konto zawodnika grupy treningowej
    register(data) {
      teamResource
        .playerAccountRegister(data.email, data.profileId, data.teamId)
        .then(() => {
          this.$store.dispatch('team/player/list', { teamId: tryParseInt(this.teamId) });
          this.$store.dispatch('notifySuccess', { title: 'messages.players.register' });
        })
        .catch(() => this.$store.dispatch('notifyError', { title: 'messages.players.registerError' }));
    }
  },
  components: {
    ComponentTable,
    playerModal,
    accountModal
  }
};
</script>
